export default Object.freeze({
  APP_LOGO: {
    WHITE: "/images/logo-white.png",
    BLACK: "/images/logo-black.png",
    DEFAULT: "/images/logo-black.png",
  },

  ENDPOINTS: {
    Admin: {
      STATISTICS: "/api/admin/statistics",
      UPCOMING_INTERESTED_COURSE: "/api/model/upcoming-interested-user",
    },
    USER: {
      ALL: "/api/model/user",
      SINGLE: "/api/model/user/",
      UPDATE: "/api/model/payroll/",
      CREATE: "/api/model/course",
      DEACTIVATE: "/api/admin/deactivate/mentee/",
    },
    CART: {
      SINGLE: "/api/model/cart/",
    },
    ORDER: {
      USER_LIST: "/api/model/order/user/",
      LIST: "/api/model/order",
    },
    STUDENT: {
      SINGLE: "/api/admin/student/",
    },
    NOTIFICATION: {
      DELIVER: "/api/admin/notification/",
      GET_ADMIN_NOTIFICATIONS: "/api/admin/notifications/",
    },
    PAYROLL: {
      ALL: "/api/model/payroll",
      SINGLE: "/api/v1/course/",
      UPDATE: "/api/model/payroll/",
      CREATE: "/api/model/payroll",
    },

    REPORT: {
      ALL: "/api/model/report/",
    },

    QUESTION: {
      UPDATE: "/api/model/coursequestion/",
    },

    COURSE: {
      ALL: "/api/model/course",
      SINGLE: "/api/model/course/",
      REVIEW: "/api/v1/course/reviews/",
      UPDATE: "/api/model/course/",
      CREATE: "/api/model/course",
    },
    COUPON: {
      ALL: "/api/model/coupon",
      UPDATE: "/api/model/coupon/",
      CREATE: "/api/model/coupon/",
      DELETE: "/api/model/coupon/",
    },
    CLASS: {
      ALL: "/api/model/class",
      SINGLE: "/api/model/class/",
      UPDATE: "/api/model/class/",
      CREATE: "/api/model/class/",
      SCHEDULE: "/api/model/class/schedule",
      SESSION: "/api/model/class/sessions",
      STUDENTS: "/api/admin/class/students/",
      TRANSFER: "/api/admin/reschedule/",
      REMOVE_FROM_CLASS: "/api/admin/class/remove",
    },

    SESSION: {
      RESCHEDULE_LIST: "/api/admin/user/reschedule",
    },

    CURRICULUM: {
      ALL: "/api/model/curriculum",
      NAME_ALL: "/api/model/curriculum/names",
      SINGLE: "/api/model/curriculum/",
      UPDATE: "/api/model/curriculum/",
      CREATE: "/api/model/curriculum",
    },
    MENTOR_VERIFICATION: {
      ALL: "/api/model/mentor-verification",
      SINGLE: "/api/model/mentor-verification/",
      UPDATE: "/api/model/mentor-verification/",
      UPDATE_STATUS: "/api/admin/mentor/verification/",
    },
    MEDIA: {
      ALL: "/api/model/media",
      SINGLE: "/api/model/media/",
      CREATE_SINGLE: "/api/model/media/",
    },
    MENTOR: {
      ALL: "/api/admin/mentor/",
      SLOTS: "/api/admin/mentor/slots/",
      COUNSELLING_SESSIONS: "/api/model/counselling",
      COUNSELLING_SESSIONS_UPDATE: "/api/model/counselling/",
      CANCEL_COUNSELLING_SESSION: "/api/admin/counselling/cancel/",
      SINGLE: "/api/admin/mentor/",
      SINGLE2: "/api/admin/mentor/",
      CREATE_SINGLE: "/api/admin/mentor/create",
      UPDATE_SINGLE: "/api/admin/mentor/",
      QUESTIONS: "/api/admin/mentor/questions/",
      DELETE: "/api/admin/mentor/",
    },
    GLOBAL: {
      GET: "/api/v1/global",
      UPDATE: "/api/model/global/",
    },
  },

  CURRENCY_SYMBOL: "₹",
  DEFAULT_PROFILE_PICTURE:
    "https://www.americanaircraftsales.com/wp-content/uploads/2016/09/no-profile-img.jpg",

  Error: {
    FETCH: "Unable to Load!",
    SUBMIT: "Unable to connect to server",
    UNKNOWN: "Something Went Wrong",
  },

  Curriculum: {
    Types: ["recorded", "live-single", "live-group"],
    Type: {
      RECORDED: "recorded",
      LIVE_SINGLE: "live-single",
      LIVE_GROUP: "live-group",
    },
    Default: "recorded",
  },
  Topic: {
    Types: ["Recorded", "Session", "Assignment", "Link"],
    Default: "Recorded",
  },
  Course: {
    Types: [
      "Pre-recorded",
      "Live Session 1 on 1",
      "Live Group Session",
      "Subscription",
    ],

    Type: {
      RECORDED: "Pre-recorded",
      LIVE_SINGLE: "Live Session 1 on 1",
      LIVE_GROUP: "Live Group Session",
      SUBSCRIPTION: "Subscription",
    },
    DefaultType: "Pre-recorded",
    Status: ["Upcoming", "Published", "Unpublished"],
    DefaultStatus: "Published",
  },

  Notification: {
    Scope: ["ALL", "MENTEES", "MENTORS", "ADMINS", "SINGLE"],
    Channels: ["EMAIL", "SMS", "APP"],
  },

  Mentor: {
    Account: {
      Types: [
        { value: "current", label: "Current" },
        { value: "saving", label: "Saving" },
      ],
      Default: "current",
    },
    Status: ["Public", "Private"],
  },

  Actions: {
    Updated: {
      Success: (obj) => {
        return obj + " Successfully Updated";
      },
    },
    Created: {
      Success: (obj) => {
        return obj + " Successfully Created";
      },
    },
  },

  Safety: {
    TRANSACTION_UPPER_LIMIT: 4000,
  },

  Grade: {
    MIN: 1,
    MAX: 12,
  },

  MONTH_SIZE: 30,
  DATE_TIME_FORMAT: "dddd, MMMM Do YYYY, h:mm a",
});
